import React, { useState, useMemo, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faComment } from "@fortawesome/free-solid-svg-icons";
import firebase from "firebase";
import { Button, Card } from "react-bootstrap";
import { INVITE_PROCESS,PROD_HOSTED_API_BASE_URL } from "../../../../config/index";
import axios from "axios";
import { useCollection } from "react-firebase-hooks/firestore";
import "@culturehq/add-to-calendar/dist/styles.css";
import { changeLanguage } from "../../../../store/actions/actions";
import { connect } from "react-redux";
import LeftBar from "../LeftBar";
import NavBar from "../NavBar";
import EventChat from "../EventChat";
import { useHistory } from "react-router";
import moment from "moment";

function Quizzes({ darkTheme, currentEvent }) {
  const history = useHistory();
  const user = firebase.auth().currentUser;
  const [showChat, setShowChat] = useState(false);

  const [quizSnapshot, quizLoading, quizError] = useCollection(
    firebase
      .firestore()
      .collection(`/events/${currentEvent?.id}/quizzes/`)
      .orderBy("order_index", "asc")
  );

  const publishedquizzesData = useMemo(() => {
    return quizSnapshot?.docs?.map((e) => {
      return { id: e.id, ...e.data() };
    });
  }, [quizSnapshot]);

  const processRoomInvite = (inviteProcessData) => {
    axios
      .post(`https://${PROD_HOSTED_API_BASE_URL}${INVITE_PROCESS}`, inviteProcessData)
      .then((response) => {
        console.log("Invite processing: ", response?.response?.data?.message);
      })
      .catch((error) => {
        console.error(
          "Error processing invite: ",
          error?.response?.data?.message
        );
      });
  };

  useEffect(() => {
    const inviteProcessData = {
      invite_code: currentEvent?.room_invite_code,
      user_id: user?.uid,
    };
    processRoomInvite(inviteProcessData);
  }, []);

  return (
    <div className="h-100">
      <LeftBar mobile />
      <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
        <NavBar />
        <div className="row" style={{ height: "93vh", overflow: "hidden" }}>
          <LeftBar />
          <div
            className="col-md-7 h-100 p-md-5 p-3 "
            data-theme={darkTheme ? "dark" : "light"}
            style={{ overflow: "scroll" }}
          >
            <div className="row">
              <div className="col-md-12 mb-3">
                <div
                  className={
                    darkTheme
                      ? "shadow-sm p-3 rounded bg-dark"
                      : "shadow-sm p-3 rounded bg-white"
                  }
                >
                  <h3>Quizzes</h3>
                </div>
              </div>
            </div>
            {publishedquizzesData?.map((quiz, index) => (
              <Card
                key={index + quiz.id}
                className={
                  darkTheme ? "bg-dark mb-2 pointer" : "bg-white mb-2 pointer"
                }
                onClick={() => {
                  if (quiz.created_by === user?.uid) {
                    return;
                  } else {
                    history.push(
                      `/event/${currentEvent?.slug}/quiz/${quiz?.content_id}`
                    );
                  }
                }}
              >
                <Card.Body>
                  <p className="mb-0 small">
                    {moment(quiz.created_at).format("LLL")}
                  </p>
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h5 className="mb-0">{quiz.title}</h5>
                    </div>
                    {quiz.created_by === user?.uid ? (
                      <Button
                        size="sm"
                        onClick={() =>
                          history.push(
                            `/admin/eventmanager/${currentEvent?.id}/quizzes`
                          )
                        }
                      >
                        View responses
                      </Button>
                    ) : null}
                  </div>
                  {quiz?.is_graded && (
                    <p className="small mt-2 mb-0">
                      <b>Total grade points: </b>
                      {quiz?.total_points}
                    </p>
                  )}
                </Card.Body>
                <Card.Footer className="border-top">
                  <p className="mb-0 small">
                    <b>Deadline by </b>
                    {moment(quiz.deadline).format("LLL")}
                  </p>
                </Card.Footer>
              </Card>
            ))}
          </div>
          <div
            className="col-md-4 h-100 px-0 d-none d-md-block"
            style={{ overflow: "scroll" }}
          >
            <EventChat
              event_id={currentEvent?.id}
              tabs={
                currentEvent?.people_enabled
                  ? [
                      {
                        name: "Chat",
                        type: "chat",
                        chatroute: `/events/${currentEvent?.id}/questionsAsked/`,
                      },
                      {
                        name: "People",
                        type: "people",
                      },
                    ]
                  : [
                      {
                        name: "Chat",
                        type: "chat",
                        chatroute: `/events/${currentEvent?.id}/questionsAsked/`,
                      },
                    ]
              }
            />
          </div>
        </div>
      </div>
      {/* Chat Mobile view */}
      {showChat && (
        <div
          className="shadow-lg border border-muted"
          style={{
            height: "55vh",
            position: "fixed",
            bottom: "17vh",
            left: 10,
          }}
        >
          <EventChat event_id={currentEvent?.id} />
        </div>
      )}
      <div
        style={{
          position: "fixed",
          height: 45,
          width: 45,
          bottom: "10.5vh",
          left: 5,
        }}
        className="bg-primary rounded-circle d-block d-md-none"
      >
        <a
          className="d-flex align-items-center justify-content-center"
          onClick={() => setShowChat((prev) => !prev)}
          style={{
            height: 45,
            width: 45,
          }}
        >
          <FontAwesomeIcon
            className="text-white"
            icon={showChat ? faTimes : faComment}
            style={{ fontSize: 20 }}
          />
        </a>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    darkTheme: state.darkTheme,
    currentEvent: state.currentEvent,
  }),
  { changeLanguage }
)(Quizzes);
